(function () {
    'use strict';

    var app = angular.module('app');

    // Configure Toastr
    toastr.options.timeOut = 4000;
    toastr.options.positionClass = 'toast-bottom-right';

    var imageSettings = {
        imageProductBasePath: '//s3.amazonaws.com/gco_bucket/products/',
        imgProdURLBase: '//s3.amazonaws.com/image-products/',
        imageProductUnknown: 'placeholder',
        imageShipLabelBasePath: '//s3.amazonaws.com/gco_bucket/shiplabels/'
    };

    // get user login + array

    var apiSettings = {
        //todo: if I move api
        base_url: '/'
    };

    var events = {
        controllerActivateSuccess: 'controller.activateSuccess',
        spinnerToggle: 'spinner.toggle'
    };

    var users = [];

    /*
    NOT SURE HOW TO GET $http added to this file
    function get_users() {
        return $http.get('/apis/users.cfc?method=get_users').error(function(data, status, headers, config) {});
    }
    get_users().then(function(httpResult) {
        for (var user in httpResult.data.data) {

            // limit data to login and id
            var payload = {
                user_id: user.user_id,
                user_login: user.user_login
            };
            users.push(payload);
        }
    });
    */

    var config = {
        appErrorPrefix: '[System Error] ', //Configure the exceptionHandler decorator
        docTitle: 'Yoda: ',
        //env: hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1),
        events: events,
        imageSettings: imageSettings,
        users: users
    };



    app.value('config', config);

    app.config(['$logProvider', function ($logProvider) {
        // turn debugging off/on (no info or warn)
        if ($logProvider.debugEnabled) {
            $logProvider.debugEnabled(true);
        }
    }]);

    //#region Configure the common services via commonConfig

    app.config(['commonConfigProvider', function (cfg) {
        cfg.config.controllerActivateSuccessEvent = config.events.controllerActivateSuccess;
        cfg.config.spinnerToggleEvent = config.events.spinnerToggle;
    }]);

})();